import { getProductFlowConfiguration } from '@flows/configs/shared/flowConfiguration'
import type { FlowConfigProps, StepConfigParams } from '@flows/configs/types'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'
import { generateGetFlowValueFunctions } from '@flows/insurance/utils'

import schema from './schema'
import getTravelHealthNxtSteps from './steps'

const FIRST_STEP_NAME = 'birth_date'
const productKey = 'travel_health_v1_berlin_direkt_de'

const getTravelHealthNxtConfig = ({ clientHelpers }: FlowConfigProps) => {
  const params: StepConfigParams = {
    clientHelpers,
    productKey,
    helperFunctions: generateGetFlowValueFunctions(productKey),
    subFlow: SubFlow.TravelHealth,
  }

  return getProductFlowConfiguration(productKey, getTravelHealthNxtSteps(params), {
    constants: {
      FIRST_STEP_NAME,
      SCHEMA: schema,
    },
    getInitialValues: () => {
      return {
        [productKey]: {
          productKey,
          configuration_parameters: {
            tariff_type: 'single',
            insured_family_members: [],
          },
        },
      }
    },
  })
}

export default getTravelHealthNxtConfig
